import React, { FC } from 'react'

import { IconDesktopProps } from './IconDesktop.types'
import * as Styled from './styles/IconDesktop.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDesktop: FC<IconDesktopProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDesktopProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconDesktopProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='m159.67 142.38-17.36-39.06A16 16 0 0 0 147 92V28a16 16 0 0 0-16-16H29a16 16 0 0 0-16 16v64a16 16 0 0 0 4.71 11.32L.35 142.38A4 4 0 0 0 4 148h152a4 4 0 0 0 4-4 3.92 3.92 0 0 0-.33-1.62zM21 28a8 8 0 0 1 8-8h102a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H29a8 8 0 0 1-8-8zM10.17 140l14.5-32.62A15.92 15.92 0 0 0 29 108h102a15.61 15.61 0 0 0 4.35-.62L149.84 140z' />
        <path d='M108 120H52a4 4 0 0 0 0 8h56a4 4 0 0 0 0-8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDesktop
